import { combineReducers } from 'redux'
import { products } from './product'
import { content } from './content'

export default combineReducers({
    products: products,
    content: content
})

